import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const tegeleraudio: IBrand = {
  id: "tegeler",
  name: BRAND.TEGELER_AUDIO,
  logo: "/logo/tegeler-square-logo.jpg",
  website: "https://www.tegeler.com/",
  description: `
Tegeler Audio Manufaktur started by Michael Krusch.   

Their ethos is to design and produce devices that help sound technicians and musicians produce the sound they want to hear. Tegeler Audio Manufaktur designs equipment with tonal qualities and musicality in mind. In today’s digital age, the demand for high-quality studio hardware is seeing an impressive resurgence, as people seek to regain what digitalisation has sometimes lost. 

The company is based in the north of Berlin, Tegel
Devices are tested not only in the workshop and testing space, but also the neighbouring studio under real-world production conditions.
All of Tegeler Audio Manufaktur’s devices are hand-manufactured from high-quality components that are carefully selected according to requirements.
`,
  videos: [
    "https://www.youtube.com/embed/XN2A0GScDDk",
  ],
}